var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 13.944,
    viewBox: "0 0 22.5 13.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".avideosvg{fill:#fff;stroke:#fff;stroke-linejoin:round;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "avideosvg",
    d: "M327.093,183.444a1.722,1.722,0,0,1-1.76-1.681V171.681a1.722,1.722,0,0,1,1.76-1.681h14.079a1.722,1.722,0,0,1,1.76,1.681V173.5l2.956-2.352a.9.9,0,0,1,.559-.2.863.863,0,0,1,.885.843v9.856a.863.863,0,0,1-.885.843.894.894,0,0,1-.559-.2l-2.956-2.352v1.819a1.722,1.722,0,0,1-1.76,1.681Zm-.88-11.763v10.083a.862.862,0,0,0,.88.84h14.079a.862.862,0,0,0,.88-.84V171.681a.862.862,0,0,0-.88-.84H327.093A.862.862,0,0,0,326.214,171.681Zm16.719,2.915v4.254l3.519,2.8V171.8Z",
    transform: "translate(-325.083 -169.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b8803a8c.svg";
export { ForwardRef as ReactComponent };